import { EvaluationAnswers } from '@/pages/Users/api/services/saveQuestionnaireAnswer';
import { Schema } from '@/utils';
import { TrainingChecklistTableTypes } from '@/pages/Users/components/TrainingChecklistTable/types';

export namespace EvaluationPreviewFormTypes {
  export type Value = {
    answers: EvaluationAnswers;
  };
  // Indexes of questions whose selected answer shows Notes (Meets / Needs Improvement) but has none.
  export const getMissingNoteIndexes = (
    questions: TrainingChecklistTableTypes.EvaluationQuestion[],
    answers: EvaluationAnswers = {}
  ): number[] =>
    questions.flatMap(({ question, options }, index) => {
      const { optionId, note } = answers[question.id] || {};
      const showsNotes = options.find((option) => option.id === optionId)?.showsNotes;
      return showsNotes && !note?.trim() ? [index] : [];
    });
  export const validator = (questions: TrainingChecklistTableTypes.EvaluationQuestion[]) =>
    Schema((z) =>
      z
        .object({ answers: z.record(z.any()) })
        .superRefine(({ answers }, ctx) =>
          getMissingNoteIndexes(questions, answers).forEach((index) =>
            ctx.addIssue({ code: 'custom', path: ['answers', questions[index].question.id, 'note'], message: 'Notes are required' })
          )
        )
    );
}
